import { useCallback } from 'react';
import { runOnJS, useAnimatedReaction, useSharedValue } from 'react-native-reanimated';

import { AutoScrollingListLoopRef } from '@/feature/fantasy-event-sheets/auto-scrolling-list/AutoScrollingListLoop';
import { RefObject } from '@testing-library/react-native/build/types';

import { useFullScreenPagerTransition } from '../FullScreenPagerTransitionProvider';

/**
 * Hook used to start the auto scroll of the AutoScrollingList, right after the mount animation has started.
 * @param autoScrollingList - ref to the AutoScrollingList
 */
export const useStartAutoScroll = (
    autoScrollingListRef: RefObject<AutoScrollingListLoopRef | null>,
    enabled: boolean = false
) => {
    const { sheetMountAnimationProgress } = useFullScreenPagerTransition();

    const hasStartedAutoScroll = useSharedValue(false);

    const startAutoScroll = useCallback(() => {
        autoScrollingListRef.current?.start();
    }, [autoScrollingListRef]);

    useAnimatedReaction(
        () => sheetMountAnimationProgress.value,
        currentValue => {
            // start the auto scroll immediately after the mount animation has started
            if (enabled && currentValue > -0.9 && !hasStartedAutoScroll.value) {
                runOnJS(startAutoScroll)();
                hasStartedAutoScroll.value = true;
            }
        }
    );
};
